(() => {
  const configNode = document.getElementById('kcPersonalizerConfig');
  const productConfigNode = document.getElementById('kcPersonalizerProductConfig');
  let productConfig = {};
  if (productConfigNode?.textContent.trim()) {
    try {
      productConfig = JSON.parse(productConfigNode.textContent);
    } catch (error) {
      console.warn('Kadehçi ürün seçenekleri okunamadı.', error);
    }
  }
  const nodeConfig = configNode ? {
    enabled: configNode.dataset.enabled !== 'false',
    templateCode: configNode.dataset.templateCode,
    glassImageUrl: configNode.dataset.glassImageUrl,
    fontUrl: configNode.dataset.fontUrl,
    fields: [1, 2].map(index => ({
      id: `kcGlassName${index}`,
      label: configNode.dataset[`field${index}Label`],
      propertyName: configNode.dataset[`field${index}Label`],
      placeholder: configNode.dataset[`field${index}Placeholder`],
      required: configNode.dataset[`field${index}Required`] !== 'false',
      maxLength: Number(configNode.dataset[`field${index}MaxLength`])
    }))
  } : {};
  const requestedTemplateCode = productConfig.presetId || productConfig.templateCode || nodeConfig.templateCode || 'kalbimiz-bir-v1';
  const configuredFieldLimit = requestedTemplateCode === 'aloha-kutulu-v1'
    ? 7
    : requestedTemplateCode === 'isimli-ikili-v1' ? 4 : 2;
  const configuredTextFields = Array.isArray(productConfig.fields)
    ? productConfig.fields
      .filter(field => field?.type === 'text')
      .sort((left, right) => {
        if (Number.isFinite(Number(left.order)) || Number.isFinite(Number(right.order))) {
          return (Number(left.order) || 999) - (Number(right.order) || 999);
        }
        const order = {left: 0, right: 1, none: 2};
        return (order[left.previewSlot] ?? 2) - (order[right.previewSlot] ?? 2);
      })
      .slice(0, configuredFieldLimit)
      .map((field, index) => ({
        ...field,
        id: `kcGlassField${index + 1}`,
        propertyName: field.label,
      }))
    : [];
  const normalizedProductConfig = Object.keys(productConfig).length ? {
    enabled: productConfig.enabled !== false,
    templateCode: requestedTemplateCode,
    presetId: productConfig.presetId || requestedTemplateCode,
    productType: productConfig.productType,
    preview: productConfig.preview,
    production: productConfig.production,
    fields: configuredTextFields.length ? configuredTextFields : undefined,
  } : {};
  const config = {
    ...(window.KadehciKalbimizBir || {}),
    ...nodeConfig,
    ...normalizedProductConfig,
    glassImageUrl: nodeConfig.glassImageUrl,
    fontUrl: nodeConfig.fontUrl,
  };
  const templateCode = config.templateCode || 'kalbimiz-bir-v1';
  const isIsimliIkili = templateCode === 'isimli-ikili-v1';
  const isAlohaKutulu = templateCode === 'aloha-kutulu-v1';
  const siblingAssetUrl = filename => config.fontUrl
    ? config.fontUrl.replace(/kc-ananda-black\.ttf/i, filename)
    : '';
  if (config.preview?.cleanImageUrl) {
    config.glassImageUrl = config.preview.cleanImageUrl;
  } else if (config.preview?.cleanImageKey) {
    config.glassImageUrl = siblingAssetUrl(config.preview.cleanImageKey);
  }
  if (!config.enabled || document.querySelector('.kc-personalizer')) return;

  const LEFT_HEART = 'M 16.472656 128.339844 C 16.796875 125.347656 17.074219 122.347656 17.453125 119.359375 C 19.878906 100.273438 27.121094 83.851562 42.148438 71.925781 C 51.886719 64.191406 62.898438 60.171875 75.265625 60.164062 C 91.199219 60.152344 105.796875 64.371094 118.1875 75.035156 C 128.984375 84.328125 135.460938 96.1875 135.882812 111.113281 C 135.996094 115.117188 136.03125 119.125 135.980469 123.128906 C 135.972656 124.042969 135.476562 124.949219 135.203125 125.863281 C 134.960938 125.863281 134.71875 125.859375 134.480469 125.859375 C 134.242188 125.011719 133.9375 124.179688 133.78125 123.316406 C 131.597656 111.085938 127.210938 99.988281 118.964844 90.699219 C 111.398438 82.179688 101.890625 77.84375 91.183594 75.640625 C 77.402344 72.796875 64.6875 75.183594 53.292969 83.839844 C 43.476562 91.296875 37.484375 101.542969 34.617188 113.691406 C 28.628906 139.058594 36.480469 160.148438 54.03125 177.671875 C 62.71875 186.351562 72.441406 193.898438 81.3125 202.394531 C 90.367188 211.0625 99.285156 219.941406 107.640625 229.332031 C 115.019531 237.628906 121.824219 246.539062 128.351562 255.589844 C 133.160156 262.253906 137.730469 269.265625 139.105469 277.832031 C 139.210938 278.480469 139.28125 279.136719 139.003906 279.949219 C 138.4375 279.121094 137.859375 278.304688 137.308594 277.46875 C 127.132812 262.023438 115.945312 247.441406 102.136719 235.347656 C 95.425781 229.464844 87.980469 224.496094 80.933594 219.023438 C 66.347656 207.707031 51.835938 196.304688 38.796875 183.023438 C 26.773438 170.785156 19.09375 156.265625 17.160156 138.703125 C 16.875 136.128906 16.699219 133.542969 16.472656 130.960938 Z M 16.472656 128.339844';
  const RIGHT_HEART = 'M 139.269531 128.339844 C 138.941406 125.347656 138.664062 122.347656 138.285156 119.359375 C 135.863281 100.273438 128.621094 83.851562 113.59375 71.925781 C 103.851562 64.195312 92.84375 60.171875 80.476562 60.164062 C 64.542969 60.152344 49.945312 64.371094 37.554688 75.035156 C 26.757812 84.328125 20.28125 96.1875 19.855469 111.113281 C 19.746094 115.117188 19.710938 119.125 19.757812 123.128906 C 19.769531 124.042969 20.265625 124.949219 20.539062 125.863281 C 20.78125 125.863281 21.019531 125.859375 21.261719 125.859375 C 21.496094 125.011719 21.804688 124.179688 21.957031 123.316406 C 24.144531 111.085938 28.53125 99.988281 36.777344 90.699219 C 44.339844 82.179688 53.851562 77.84375 64.558594 75.640625 C 78.339844 72.796875 91.050781 75.183594 102.449219 83.84375 C 112.265625 91.300781 118.257812 101.542969 121.125 113.691406 C 127.113281 139.058594 119.261719 160.148438 101.710938 177.671875 C 93.019531 186.351562 83.300781 193.898438 74.429688 202.394531 C 65.375 211.0625 56.453125 219.945312 48.101562 229.332031 C 40.71875 237.628906 33.917969 246.539062 27.386719 255.589844 C 22.582031 262.253906 18.011719 269.265625 16.636719 277.828125 C 16.53125 278.480469 16.460938 279.136719 16.738281 279.945312 C 17.300781 279.121094 17.882812 278.304688 18.433594 277.46875 C 28.605469 262.023438 39.792969 247.441406 53.601562 235.347656 C 60.316406 229.464844 67.757812 224.496094 74.808594 219.023438 C 89.390625 207.707031 103.90625 196.304688 116.945312 183.023438 C 128.964844 170.785156 136.644531 156.265625 138.582031 138.703125 C 138.867188 136.128906 139.042969 133.542969 139.269531 130.960938 Z M 139.269531 128.339844';
  const unitsPerMm = 124.724 / 44;
  const maxNameWidth = 42 * unitsPerMm;
  const kalbimizDefaultFields = [
    {
      id: 'kcGlassName1',
      label: '1. Kadeh Üzerindeki İsim',
      propertyName: '1. Kadeh Üzerindeki İsim',
      placeholder: 'Kadeh üzerinde yazmasını istediğiniz ismi giriniz',
      required: true,
      maxLength: 16
    },
    {
      id: 'kcGlassName2',
      label: '2. Kadeh Üzerindeki İsim',
      propertyName: '2. Kadeh Üzerindeki İsim',
      placeholder: 'Kadeh üzerinde yazmasını istediğiniz ismi giriniz',
      required: true,
      maxLength: 16
    }
  ];
  const isimliDefaultFields = [
    {
      id: 'kcGlassField1',
      label: '1. Kadeh - İsim',
      propertyName: '1. Kadeh - İsim',
      placeholder: 'İsim giriniz',
      required: true,
      maxLength: 22
    },
    {
      id: 'kcGlassField2',
      label: '1. Kadeh - Soyisim',
      propertyName: '1. Kadeh - Soyisim',
      placeholder: 'Soyisim giriniz',
      required: true,
      maxLength: 24
    },
    {
      id: 'kcGlassField3',
      label: '2. Kadeh - İsim',
      propertyName: '2. Kadeh - İsim',
      placeholder: 'İsim giriniz',
      required: true,
      maxLength: 22
    },
    {
      id: 'kcGlassField4',
      label: '2. Kadeh - Soyisim',
      propertyName: '2. Kadeh - Soyisim',
      placeholder: 'Soyisim giriniz',
      required: true,
      maxLength: 24
    }
  ];
  const alohaDefaultFields = [
    {...isimliDefaultFields[0], id: 'kcAlohaField1'},
    {...isimliDefaultFields[1], id: 'kcAlohaField2'},
    {...isimliDefaultFields[2], id: 'kcAlohaField3'},
    {...isimliDefaultFields[3], id: 'kcAlohaField4'},
    {
      id: 'kcAlohaField5',
      label: 'Kutu Üzeri - İsim',
      propertyName: 'Kutu Üzeri - İsim',
      placeholder: 'Kutu üzerine yazılacak ismi giriniz',
      required: true,
      maxLength: 22
    },
    {
      id: 'kcAlohaField6',
      label: 'Kutu Üzeri - Soyisim',
      propertyName: 'Kutu Üzeri - Soyisim',
      placeholder: 'Kutu üzerine yazılacak soyismi giriniz',
      required: true,
      maxLength: 24
    },
    {
      id: 'kcAlohaField7',
      label: 'Kutu Alt Notu',
      propertyName: 'Kutu Alt Notu',
      placeholder: 'Kutu altındaki özel mesajı giriniz',
      defaultValue: 'İÇİN ÖZEL OLARAK ÜRETİLMİŞTİR',
      multiline: true,
      required: false,
      maxLength: 52
    }
  ];
  const defaultFields = isAlohaKutulu ? alohaDefaultFields : isIsimliIkili ? isimliDefaultFields : kalbimizDefaultFields;
  const minimumSuppliedFields = isAlohaKutulu ? 7 : isIsimliIkili ? 4 : 0;
  const suppliedFields = Array.isArray(config.fields) && config.fields.length >= minimumSuppliedFields
    ? config.fields
    : [];
  const fields = defaultFields.map((fallback, index) => {
    const supplied = suppliedFields[index] || {};
    return {
      ...fallback,
      ...supplied,
      required: supplied.required === undefined ? fallback.required : Boolean(supplied.required),
      maxLength: Math.max(1, Math.min(80, Number(supplied.maxLength) || fallback.maxLength))
    };
  });

  const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));

  function replaceGlobo(productForm) {
    if (!productForm) return;
    productForm.enctype = 'multipart/form-data';
    productForm.querySelectorAll('.gpo-container').forEach(globo => {
      globo.dataset.kcReplaced = 'true';
      globo.hidden = true;
      globo.setAttribute('aria-hidden', 'true');
      globo.querySelectorAll('input, select, textarea, button').forEach(control => { control.disabled = true; });
    });
    productForm.querySelectorAll('[name="properties[_has_gpo]"], [name^="properties[_gpo_"]').forEach(input => { input.disabled = true; });

    if (!productForm.dataset.kcCartSubmit) {
      productForm.dataset.kcCartSubmit = 'true';
      const submitProduct = async event => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const productFormElement = productForm.closest('product-form');
        const clickedButton = event.target?.closest?.('button[name="add"], button[type="submit"]');
        const submitButton = clickedButton || [...productForm.querySelectorAll('[type="submit"]')]
          .find(button => button.offsetWidth > 0 && button.offsetHeight > 0)
          || productForm.querySelector('[type="submit"]');
        const spinner = submitButton?.querySelector('.loading__spinner');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (submitButton?.getAttribute('aria-disabled') === 'true') return;
        submitButton?.setAttribute('aria-disabled', 'true');
        submitButton?.classList.add('loading');
        spinner?.classList.remove('hidden');

        try {
          const request = typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/json' } };
          request.headers ||= {};
          request.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete request.headers['Content-Type'];

          const formData = new FormData(productForm);
          if (cart?.getSectionsToRender) {
            formData.append('sections', cart.getSectionsToRender().map(section => section.id));
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement?.(document.activeElement);
          }
          request.body = formData;

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', request).then(result => result.json());
          if (response.status) throw new Error(response.description || response.message || 'Ürün sepete eklenemedi.');

          if (cart?.renderContents) cart.renderContents(response);
          else window.location.href = window.routes?.cart_url || '/cart';
        } catch (error) {
          productFormElement?.handleErrorMessage?.(error.message || 'Ürün sepete eklenemedi.');
          console.error(error);
        } finally {
          submitButton?.classList.remove('loading');
          submitButton?.removeAttribute('aria-disabled');
          spinner?.classList.add('hidden');
          cart?.classList.remove('is-empty');
        }
      };

      productForm._kcSubmitProduct = submitProduct;
      productForm.addEventListener('submit', submitProduct, true);

      // Globo, document seviyesinde tıklamayı yakalayabildiği için bizim işlemimiz
      // daha erken (window capture) çalışır ve ürünü doğrudan Shopify sepetine yollar.
      if (!window.__kcCartClickCapture) {
        window.__kcCartClickCapture = true;
        window.addEventListener('click', event => {
          const button = event.target?.closest?.('button[name="add"], button[type="submit"]');
          const form = button?.form;
          if (!form?._kcSubmitProduct) return;
          form._kcSubmitProduct(event);
        }, true);
      }
    }
  }

  function ensureNativeInputs() {
    const productForm = [...document.querySelectorAll('form[action*="/cart/add"]')]
      .find(form => form.querySelector('button[name="add"], button[type="submit"]'));
    if (!productForm) return null;

    let nativeOptions = productForm.querySelector('.kc-native-options');
    if (!nativeOptions) {
      nativeOptions = document.createElement('div');
      nativeOptions.className = 'kc-native-options';
      nativeOptions.setAttribute('aria-label', 'Kadeh kişiselleştirme bilgileri');
      nativeOptions.innerHTML = fields.map((field, index) => `
        <div class="kc-native-field">
          <div class="kc-native-label-row">
            <label for="${escapeHtml(field.id)}">${escapeHtml(field.label)}${field.required ? ' <span aria-hidden="true">*</span>' : ''}</label>
            <small><b data-kc-count="${index + 1}">0</b>/${field.maxLength}</small>
          </div>
          ${field.multiline
            ? `<textarea id="${escapeHtml(field.id)}" class="kc-native-input kc-native-input--textarea" name="properties[${escapeHtml(field.propertyName || field.label)}]" maxlength="${field.maxLength}" placeholder="${escapeHtml(field.placeholder)}" rows="2" autocomplete="off" spellcheck="false"${field.required ? ' required' : ''}>${escapeHtml(field.defaultValue || '')}</textarea>`
            : `<input id="${escapeHtml(field.id)}" class="kc-native-input" type="text" name="properties[${escapeHtml(field.propertyName || field.label)}]" maxlength="${field.maxLength}" placeholder="${escapeHtml(field.placeholder)}" value="${escapeHtml(field.defaultValue || '')}" autocomplete="off" spellcheck="false"${field.required ? ' required' : ''}>`}
        </div>`).join('');

      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const quantityBlock = quantityInput?.closest('[id^="Quantity-Form-"]') || quantityInput?.closest('.quantity') || quantityInput;
      const buttons = productForm.querySelector('.product-form__buttons');
      if (quantityBlock?.parentNode) quantityBlock.parentNode.insertBefore(nativeOptions, quantityBlock);
      else if (buttons) buttons.prepend(nativeOptions);
      else productForm.prepend(nativeOptions);
    }

    replaceGlobo(productForm);
    if (!productForm.dataset.kcGloboObserver) {
      productForm.dataset.kcGloboObserver = 'true';
      new MutationObserver(() => replaceGlobo(productForm)).observe(productForm, { childList: true, subtree: true });
    }

    return [...nativeOptions.querySelectorAll('.kc-native-input')];
  }

  function enhanceGallery(tries = 0) {
    const gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) {
      if (tries < 40) setTimeout(() => enhanceGallery(tries + 1), 150);
      return;
    }
    if (gallery.dataset.kcPremium === 'true') return;
    gallery.dataset.kcPremium = 'true';
    gallery.classList.add('kc-premium-gallery');

    const items = [...gallery.querySelectorAll('.product__media-item')];
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    gallery.querySelectorAll('.product__media').forEach(frame => {
      const image = frame.querySelector('img');
      if (!image) return;
      frame.classList.add('kc-inline-zoom');
      frame.addEventListener('pointermove', event => {
        if (!finePointer.matches) return;
        const rect = frame.getBoundingClientRect();
        const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
        image.style.setProperty('--kc-zoom-x', `${x}%`);
        image.style.setProperty('--kc-zoom-y', `${y}%`);
        frame.classList.add('is-zooming');
      });
      frame.addEventListener('pointerleave', () => {
        frame.classList.remove('is-zooming');
        image.style.removeProperty('--kc-zoom-x');
        image.style.removeProperty('--kc-zoom-y');
      });
    });
    const badge = document.createElement('span');
    badge.className = 'kc-gallery-badge';
    badge.textContent = 'Kişiye özel';
    gallery.appendChild(badge);

    const count = document.createElement('span');
    count.className = 'kc-gallery-count';
    count.setAttribute('aria-live', 'polite');
    gallery.appendChild(count);

    function updateCount() {
      const activeThumb = gallery.querySelector('.thumbnail[aria-current="true"]');
      const thumbs = [...gallery.querySelectorAll('.thumbnail')];
      let index = activeThumb ? thumbs.indexOf(activeThumb) : -1;
      if (index < 0) {
        const visibleItem = items.findIndex(item => item.getBoundingClientRect().width > 0 && item.getAttribute('aria-hidden') !== 'true');
        index = visibleItem < 0 ? 0 : visibleItem;
      }
      count.textContent = `${Math.min(index + 1, Math.max(items.length, 1))} / ${Math.max(items.length, 1)}`;
    }

    gallery.addEventListener('click', () => requestAnimationFrame(updateCount));
    gallery.addEventListener('slideChanged', updateCount);
    new MutationObserver(updateCount).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'aria-hidden'] });
    updateCount();
  }

  function enhanceCareStrip(tries = 0) {
    const care = document.querySelector('.kc-care-strip');
    if (!care) {
      if (tries < 30) setTimeout(() => enhanceCareStrip(tries + 1), 150);
      return;
    }
    if (care.dataset.kcEnhanced === 'true') return;
    const description = care.querySelector('span')?.textContent?.trim()
      || 'Baskının uzun ömürlü kalması için kadehlerinizi ılık suda ve elde yıkayın.';
    care.dataset.kcEnhanced = 'true';
    care.setAttribute('aria-label', 'Yıkama talimatı ve baskı koruma uyarısı');
    care.innerHTML = `
      <div class="kc-care-head">
        <span class="kc-care-eyebrow">Baskı koruma uyarısı</span>
        <strong>Yıkama Talimatı</strong>
        <p>${escapeHtml(description)}</p>
      </div>
      <div class="kc-care-rules" aria-label="Uygun yıkama yöntemleri">
        <div class="kc-care-rule">
          <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M5 18h38l-4 20H9L5 18zM8 23c4-3 7 3 11 0s7 3 11 0 7 3 11 0M17 16c1-5 4-8 8-8 3 0 5 2 5 5 0 4-4 6-7 8"/></svg>
          <span><b>Elde yıkayın</b><small>Nazikçe temizleyin</small></span>
        </div>
        <div class="kc-care-rule">
          <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M19 8a5 5 0 0110 0v20a9 9 0 11-10 0V8zM24 15v18M15 41h18"/></svg>
          <span><b>Ilık su kullanın</b><small>Yüksek ısıdan kaçının</small></span>
        </div>
        <div class="kc-care-rule kc-care-rule--avoid">
          <svg viewBox="0 0 48 48" aria-hidden="true"><rect x="8" y="7" width="32" height="34" rx="3"/><path d="M8 15h32M15 11h1M21 11h1M15 32c5-5 13-5 18 0M6 6l36 36"/></svg>
          <span><b>Makineye atmayın</b><small>Baskıyı koruyun</small></span>
        </div>
      </div>`;
  }

  function waitForInputs(tries = 0) {
    const inputs = ensureNativeInputs();
    const expectedCount = isAlohaKutulu ? 7 : isIsimliIkili ? 4 : 2;
    if (!inputs || inputs.length < expectedCount) {
      if (tries < 80) setTimeout(() => waitForInputs(tries + 1), 150);
      return;
    }
    mount(inputs.slice(0, expectedCount));
  }

  function mount(inputs) {
    const [leftInput, leftSurnameInput, rightGivenInput, rightSurnameInput] = (isIsimliIkili || isAlohaKutulu)
      ? inputs
      : [inputs[0], null, inputs[1], null];
    const rightInput = (isIsimliIkili || isAlohaKutulu) ? rightGivenInput : inputs[1];
    if (config.fontUrl) {
      const style = document.createElement('style');
      style.textContent = `
        @font-face{font-family:"Ananda Black";src:url("${config.fontUrl}") format("truetype");font-display:swap}
        @font-face{font-family:"Beautiful Heart";src:url("${siblingAssetUrl('kc-beautiful-heart-tr.ttf')}") format("truetype");font-display:swap}
        @font-face{font-family:"Cinzel";src:url("${siblingAssetUrl('kc-cinzel-regular.otf')}") format("opentype");font-display:swap}`;
      document.head.appendChild(style);
    }

    inputs.forEach((input, index) => { input.maxLength = fields[index].maxLength; });

    const root = document.createElement('section');
    root.className = 'kc-personalizer';
    root.setAttribute('aria-label', 'Kadeh kişiselleştirme önizlemesi');
    const designMarkup = isAlohaKutulu ? `
        <svg class="kc-personalizer__design kc-personalizer__design--aloha" viewBox="0 0 2500 2500" aria-label="Kutu ve iki kadeh tasarım önizlemesi">
          <g transform="translate(1465 815) scale(2.68)">
            <g transform="translate(0 8.504)">
              <image href="${escapeHtml(siblingAssetUrl('kc-aloha-kadeh-motif.svg'))}" x="0" y="0" width="155.906" height="340.157"></image>
              <text id="kcLeftGiven" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--given" x="77.953" y="136" text-anchor="middle">İsim</text>
              <text id="kcLeftSurname" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--surname" x="77.953" y="174" text-anchor="middle">SOYİSİM</text>
            </g>
          </g>
          <g transform="translate(1935 815) scale(2.68)">
            <g transform="translate(0 8.504)">
              <image href="${escapeHtml(siblingAssetUrl('kc-aloha-kadeh-motif.svg'))}" x="0" y="0" width="155.906" height="340.157"></image>
              <text id="kcRightGiven" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--given" x="77.953" y="136" text-anchor="middle">İsim</text>
              <text id="kcRightSurname" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--surname" x="77.953" y="174" text-anchor="middle">SOYİSİM</text>
            </g>
          </g>
          <g class="kc-personalizer__aloha-box">
            <text id="kcBoxGiven" class="kc-personalizer__aloha-box-given" x="735" y="1140" text-anchor="middle">İsim</text>
            <text id="kcBoxSurname" class="kc-personalizer__aloha-box-surname" x="735" y="1260" text-anchor="middle">SOYİSİM</text>
            <text id="kcBoxNote" class="kc-personalizer__aloha-box-note" x="735" y="1360" text-anchor="middle"></text>
          </g>
        </svg>` : isIsimliIkili ? `
        <svg class="kc-personalizer__design kc-personalizer__design--left kc-personalizer__design--isimli" viewBox="0 0 155.906 340.157" aria-label="Birinci kadeh tasarım önizlemesi">
          <image href="${escapeHtml(siblingAssetUrl('kc-isimli-ikili-motif.svg'))}" x="0" y="0" width="155.906" height="340.157"></image>
          <text id="kcLeftGiven" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--given" x="77.953" y="136" text-anchor="middle">İsim</text>
          <text id="kcLeftSurname" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--surname" x="77.953" y="174" text-anchor="middle">SOYİSİM</text>
        </svg>
        <svg class="kc-personalizer__design kc-personalizer__design--right kc-personalizer__design--isimli" viewBox="0 0 155.906 340.157" aria-label="İkinci kadeh tasarım önizlemesi">
          <image href="${escapeHtml(siblingAssetUrl('kc-isimli-ikili-motif.svg'))}" x="0" y="0" width="155.906" height="340.157"></image>
          <text id="kcRightGiven" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--given" x="77.953" y="136" text-anchor="middle">İsim</text>
          <text id="kcRightSurname" class="kc-personalizer__isimli-name kc-personalizer__isimli-name--surname" x="77.953" y="174" text-anchor="middle">SOYİSİM</text>
        </svg>` : `
        <svg class="kc-personalizer__design kc-personalizer__design--left" viewBox="0 0 155.906 340.157" aria-label="Birinci kadeh tasarım önizlemesi">
          <defs><path id="kcLeftNamePath" d="M 31.81 169.35 L 124.32 244.26"></path></defs>
          <path class="kc-personalizer__heart" d="${LEFT_HEART}"></path>
          <text class="kc-personalizer__name" text-anchor="middle"><textPath id="kcLeftText" href="#kcLeftNamePath" startOffset="50%">İsim</textPath></text>
        </svg>
        <svg class="kc-personalizer__design kc-personalizer__design--right" viewBox="0 0 155.906 340.157" aria-label="İkinci kadeh tasarım önizlemesi">
          <defs><path id="kcRightNamePath" d="M 31.81 244.26 L 124.32 169.35"></path></defs>
          <path class="kc-personalizer__heart" d="${RIGHT_HEART}"></path>
          <text class="kc-personalizer__name" text-anchor="middle"><textPath id="kcRightText" href="#kcRightNamePath" startOffset="50%">İsim</textPath></text>
        </svg>`;
    root.innerHTML = `
      <div class="kc-personalizer__head"><strong>Canlı önizleme</strong><span>İsimler yazıldıkça güncellenir</span></div>
      <div class="kc-personalizer__stage">
        <img src="${escapeHtml(config.glassImageUrl || '')}" alt="İki adet boş rakı kadehi">
        ${designMarkup}
      </div>
      <p class="kc-personalizer__note">Bu görsel sipariş öncesi yaklaşık önizlemedir. Yazdığınız isimler siparişinizle birlikte üretime aktarılır.</p>`;

    const firstGroup = inputs[0].closest('.gpo-element') || inputs[0].parentElement;
    const lastGroup = inputs.at(-1).closest('.gpo-element') || inputs.at(-1).parentElement;
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const mediaGallery = mediaWrapper?.querySelector('media-gallery');
    const mobileMedia = window.matchMedia('(max-width: 749px)');

    function placePreview() {
      if (mobileMedia.matches && lastGroup?.parentNode) {
        root.classList.remove('kc-personalizer--media');
        root.classList.add('kc-personalizer--mobile-inline');
        lastGroup.insertAdjacentElement('afterend', root);
      } else if (mediaWrapper && mediaGallery) {
        root.classList.remove('kc-personalizer--mobile-inline');
        root.classList.add('kc-personalizer--media');
        mediaWrapper.insertBefore(root, mediaGallery);
      } else if (firstGroup?.parentNode) {
        firstGroup.parentNode.insertBefore(root, firstGroup);
      }
    }
    root.hidden = true;
    placePreview();

    const leftText = root.querySelector('#kcLeftText');
    const rightText = root.querySelector('#kcRightText');
    const leftName = leftText?.closest('text');
    const rightName = rightText?.closest('text');
    const isimliNodes = (isIsimliIkili || isAlohaKutulu) ? {
      leftGiven: root.querySelector('#kcLeftGiven'),
      leftSurname: root.querySelector('#kcLeftSurname'),
      rightGiven: root.querySelector('#kcRightGiven'),
      rightSurname: root.querySelector('#kcRightSurname'),
    } : null;
    const alohaNodes = isAlohaKutulu ? {
      boxGiven: root.querySelector('#kcBoxGiven'),
      boxSurname: root.querySelector('#kcBoxSurname'),
      boxNote: root.querySelector('#kcBoxNote'),
    } : null;
    const counters = inputs.map((_, index) => document.querySelector(`[data-kc-count="${index + 1}"]`));

    function fit(textNode) {
      const baseSize = 30;
      const minSize = 13;
      textNode.style.fontSize = `${baseSize}px`;
      const renderedWidth = textNode.getComputedTextLength();
      const size = renderedWidth > maxNameWidth ? Math.max(minSize, baseSize * maxNameWidth / renderedWidth) : baseSize;
      textNode.style.fontSize = `${Math.round(size * 100) / 100}px`;
    }

    function fitDirect(textNode, baseSize, minSize) {
      textNode.style.fontSize = `${baseSize}px`;
      const renderedWidth = textNode.getComputedTextLength();
      const maxWidth = 47 / 55 * 155.906;
      const size = renderedWidth > maxWidth
        ? Math.max(minSize, baseSize * maxWidth / renderedWidth)
        : baseSize;
      textNode.style.fontSize = `${Math.round(size * 100) / 100}px`;
    }

    function fitToWidth(textNode, baseSize, minSize, maxWidth) {
      textNode.style.fontSize = `${baseSize}px`;
      const renderedWidth = textNode.getComputedTextLength();
      const size = renderedWidth > maxWidth
        ? Math.max(minSize, baseSize * maxWidth / renderedWidth)
        : baseSize;
      textNode.style.fontSize = `${Math.round(size * 100) / 100}px`;
    }

    function fitTspansToWidth(textNode, baseSize, minSize, maxWidth) {
      textNode.style.fontSize = `${baseSize}px`;
      const renderedWidth = Math.max(
        ...Array.from(textNode.querySelectorAll('tspan'), span => span.getComputedTextLength()),
        0,
      );
      const size = renderedWidth > maxWidth
        ? Math.max(minSize, baseSize * maxWidth / renderedWidth)
        : baseSize;
      textNode.style.fontSize = `${Math.round(size * 100) / 100}px`;
    }

    function renderAlohaNote(node, value) {
      const words = (value || '').trim().toLocaleUpperCase('tr-TR').split(/\s+/).filter(Boolean);
      const lines = ['', ''];
      words.forEach(word => {
        const firstCandidate = `${lines[0]} ${word}`.trim();
        if (!lines[1] && firstCandidate.length <= 22) lines[0] = firstCandidate;
        else lines[1] = `${lines[1]} ${word}`.trim();
      });
      if (!words.length) {
        node.replaceChildren();
        return;
      }
      node.replaceChildren();
      lines.forEach((line, index) => {
        const span = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        span.setAttribute('x', '735');
        span.setAttribute('dy', index ? '42' : '0');
        span.textContent = line;
        node.appendChild(span);
      });
      fitTspansToWidth(node, 48, 36, 288);
    }

    function update() {
      const leftValue = leftInput.value.trim();
      const rightValue = rightInput.value.trim();
      if (isIsimliIkili || isAlohaKutulu) {
        const values = {
          leftGiven: leftValue,
          leftSurname: leftSurnameInput.value.trim(),
          rightGiven: rightValue,
          rightSurname: rightSurnameInput.value.trim(),
        };
        isimliNodes.leftGiven.textContent = values.leftGiven || 'İsim';
        isimliNodes.leftSurname.textContent = values.leftSurname.toLocaleUpperCase('tr-TR') || 'SOYİSİM';
        isimliNodes.rightGiven.textContent = values.rightGiven || 'İsim';
        isimliNodes.rightSurname.textContent = values.rightSurname.toLocaleUpperCase('tr-TR') || 'SOYİSİM';
        Object.entries(isimliNodes).forEach(([key, node]) => {
          node.classList.toggle('kc-personalizer__empty', !values[key]);
        });
        fitDirect(isimliNodes.leftGiven, 41, 14);
        fitDirect(isimliNodes.leftSurname, 29, 9);
        fitDirect(isimliNodes.rightGiven, 41, 14);
        fitDirect(isimliNodes.rightSurname, 29, 9);
        if (isAlohaKutulu) {
          const boxGivenValue = inputs[4].value.trim();
          const boxSurnameValue = inputs[5].value.trim();
          const boxNoteValue = inputs[6].value.trim();
          alohaNodes.boxGiven.textContent = boxGivenValue || 'İsim';
          alohaNodes.boxSurname.textContent = boxSurnameValue.toLocaleUpperCase('tr-TR') || 'SOYİSİM';
          alohaNodes.boxGiven.classList.toggle('kc-personalizer__empty', !boxGivenValue);
          alohaNodes.boxSurname.classList.toggle('kc-personalizer__empty', !boxSurnameValue);
          fitToWidth(alohaNodes.boxGiven, 100, 58, 392);
          fitToWidth(alohaNodes.boxSurname, 84, 46, 392);
          renderAlohaNote(alohaNodes.boxNote, boxNoteValue);
        }
      } else {
        leftText.textContent = leftValue || 'İsim';
        rightText.textContent = rightValue || 'İsim';
        leftName.classList.toggle('kc-personalizer__empty', !leftValue);
        rightName.classList.toggle('kc-personalizer__empty', !rightValue);
        fit(leftName);
        fit(rightName);
      }
      counters.forEach((counter, index) => {
        if (counter) counter.textContent = String(inputs[index].value.length);
      });

      if (mediaGallery) {
        const hasName = (isAlohaKutulu ? inputs.slice(0, 6) : inputs).some(input => input.value.trim());
        root.hidden = !hasName;
        mediaGallery.hidden = mobileMedia.matches ? false : hasName;
        root.setAttribute('aria-live', hasName ? 'polite' : 'off');
      }

    }

    inputs.forEach(input => input.addEventListener('input', update));

    mobileMedia.addEventListener?.('change', event => {
      placePreview();
      update();
    });

    const addButton = [...document.querySelectorAll('button[type="submit"], button[name="add"]')]
      .find(button => button.closest('form[action*="/cart/add"]'));
    const productForm = addButton?.closest('form[action*="/cart/add"]');
    if (productForm) {
      const metadata = {
        'properties[_Kişiselleştirme Tasarımı]': config.templateCode || 'kalbimiz-bir-v1',
        'properties[_Üretim Dosyası Sürümü]': 'cmyk400-vector-layered-v1',
        'properties[_Kişiselleştirme Sistemi]': 'kadehci-native-v1'
      };
      Object.entries(metadata).forEach(([name, value]) => {
        if (productForm.querySelector(`input[name="${name}"]`)) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        productForm.appendChild(input);
      });
    }

    document.fonts?.ready.then(update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {
    waitForInputs();
    enhanceCareStrip();
    enhanceGallery();
  });
  else {
    waitForInputs();
    enhanceCareStrip();
    enhanceGallery();
  }
})();
